import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }

interface Props {
  headTitle: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroSection',
  props: {
    headTitle: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "decorator" }, "::", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "decorator" }, "||", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("br", { class: "break-if-narrow" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.headTitle) + " ", 1),
      _cache[3] || (_cache[3] = _createElementVNode("br", { class: "break-if-narrow" }, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "decorator" }, "||", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "decorator" }, "::", -1))
    ])
  ]))
}
}

})